const CANDIDATES = [
  { name: "Terracotta (current)", hex: "#C2410C" },
  { name: "Brick Red", hex: "#A8321E" },
  { name: "Rust / Sienna", hex: "#9C4A24" },
  { name: "Oxblood / Maroon", hex: "#7C2D2D" },
  { name: "Deep Teal", hex: "#0E7C6B" },
  { name: "Forest Green", hex: "#47603A" },
  { name: "Aubergine / Plum", hex: "#6E3B5A" },
  { name: "Ink Blue", hex: "#22457C" },
];

const Row = ({ name, hex }) => (
  <div className="grid grid-cols-[220px_1fr_1fr] items-stretch border-b border-[#3E2818]/10">
    <div className="flex items-center gap-3 px-6 py-6">
      <span className="w-7 h-7 rounded-full shrink-0" style={{ backgroundColor: hex }} />
      <div>
        <div className="text-sm font-semibold text-[#3E2818]">{name}</div>
        <div className="font-mono2 text-[11px] text-[#3E2818]/50">{hex}</div>
      </div>
    </div>
    {/* On cream */}
    <div className="bg-[#F7F5F0] flex items-center gap-6 px-8 py-6">
      <span className="font-display text-2xl font-medium text-[#3E2818]">Intugle<span style={{ color: hex }}>.</span></span>
      <span className="font-display text-2xl" style={{ color: hex }}>Agentic Alpha</span>
    </div>
    {/* On espresso */}
    <div className="bg-[#211307] flex items-center gap-6 px-8 py-6">
      <span className="font-display text-2xl font-medium text-[#F7F5F0]">Intugle<span style={{ color: hex }}>.</span></span>
      <span className="font-display text-2xl" style={{ color: hex }}>Agentic Alpha</span>
    </div>
  </div>
);

export default function AAColorOptions() {
  return (
    <div className="min-h-screen bg-white">
      <div className="grid grid-cols-[220px_1fr_1fr] bg-[#211307] text-[#EDA13A] font-mono2 text-[10px] uppercase tracking-[0.24em]">
        <div className="px-6 py-3">Candidate</div>
        <div className="px-8 py-3">On Cream (navbar)</div>
        <div className="px-8 py-3">On Espresso (footer)</div>
      </div>
      {CANDIDATES.map((c) => <Row key={c.hex} {...c} />)}
    </div>
  );
}
